import { render, staticRenderFns } from "./PlatformRecommendation.vue?vue&type=template&id=8fa6e606"
import script from "./PlatformRecommendation.vue?vue&type=script&lang=js"
export * from "./PlatformRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports